export default __webpack_public_path__ + "static/media/galin_s.74cd2a4a.jpg";